/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function TimeUnit(name, id) {
    this.name = name;
    this.id = id;
  }

  TimeUnit.Default = 'minutes';
  TimeUnit.AvailableTypes = ['minutes', 'hours', 'days', 'weeks', 'months', 'years'];

  TimeUnit.Available = _.map(TimeUnit.AvailableTypes, function (intervalType) {
    return new TimeUnit(intervalType.sanitize(), intervalType);
  });

  /*
   * Public Methods
   * --------------------------------------------------------------------------------
   */
  TimeUnit.prototype.getName = function () {
    return this.name;
  };

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  TimeUnit.Build = function (data) {
    if (!data || !data.id || TimeUnit.AvailableTypes.indexOf(data.id) === -1) {
      return new TimeUnit(TimeUnit.Default.sanitize(), TimeUnit.Default);
    }
    return new TimeUnit(data.name, data.id);
  };

  return TimeUnit;
};
